import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Button, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react'
import { payoutCommissionEdit } from 'api'
import { COMMISSION_TYPES } from 'lib'
import { useAppContext } from 'hooks/useAppContext'

export const ModalChangeOrderCommissionEdit = ({ isOpen, onClose, changeOrderId, originalAmount, onSave }) => {
  const { createToast } = useAppContext()
  const [amount, setAmount] = useState(0)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    setAmount(originalAmount)
  }, [changeOrderId, originalAmount])

  const handleChange = (e) => { setAmount(e.target.value) }

  const handleSave = async () => {
    setIsSaving(true)
    try {
      await payoutCommissionEdit(COMMISSION_TYPES.ChangeOrder, changeOrderId, amount)
      setIsSaving(false)
    } catch (err) {
      setIsSaving(false)
      createToast('error', 'Error', 'Failed to update commission amount.')
    }
    onSave()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Commission</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl isRequired>
            <FormLabel>Amount</FormLabel>
            <Input type="number" name="amount" value={amount} onChange={handleChange} />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" onClick={handleSave} isLoading={isSaving}>Save</Button>
          <Button variant='ghost' onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

ModalChangeOrderCommissionEdit.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  changeOrderId: PropTypes.number,
  originalAmount: PropTypes.number,
  onSave: PropTypes.func
}
